import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

export const ItemRequestService = {
  async submitItemRequest(requestData) {
    try {
      const requestDoc = {
        itemName: requestData.itemName,
        userEmail: requestData.userEmail,
        userId: requestData.userId,
        userName: requestData.userName,
        requestedAt: serverTimestamp(),
        status: "pending",
        adminNotes: "",
        createdAt: new Date().toISOString(),
      };

      const docRef = await addDoc(collection(db, "itemRequests"), requestDoc);
      
      return {
        success: true,
        id: docRef.id,
        message: "Item request submitted successfully",
      };
    } catch (error) {
      console.error("Error submitting item request:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },

  async getAllItemRequests() {
    try {
      const requestsQuery = query(
        collection(db, "itemRequests"),
        orderBy("requestedAt", "desc")
      );
      
      const snapshot = await getDocs(requestsQuery);
      const requests = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return {
        success: true,
        data: requests,
      };
    } catch (error) {
      console.error("Error fetching item requests:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },

  async updateRequestStatus(requestId, status, adminNotes = "") {
    try {
      const requestRef = doc(db, "itemRequests", requestId);
      await updateDoc(requestRef, {
        status,
        adminNotes,
        updatedAt: serverTimestamp(),
      });

      return {
        success: true,
        message: "Request status updated successfully",
      };
    } catch (error) {
      console.error("Error updating request status:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },

  async deleteRequest(requestId) {
    try {
      await deleteDoc(doc(db, "itemRequests", requestId));
      
      return {
        success: true,
        message: "Request deleted successfully",
      };
    } catch (error) {
      console.error("Error deleting request:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },

  async getRequestsByUser(userEmail) {
    try {
      const requestsQuery = query(
        collection(db, "itemRequests"),
        where("userEmail", "==", userEmail),
        orderBy("requestedAt", "desc")
      );
      
      const snapshot = await getDocs(requestsQuery);
      const requests = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return {
        success: true,
        data: requests,
      };
    } catch (error) {
      console.error("Error fetching user requests:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },

  async checkDuplicateRequest(userEmail, itemName) {
    try {
      const requestsQuery = query(
        collection(db, "itemRequests"),
        where("userEmail", "==", userEmail),
        where("itemName", "==", itemName),
        where("status", "==", "pending")
      );
      
      const snapshot = await getDocs(requestsQuery);
      
      return {
        success: true,
        hasDuplicate: !snapshot.empty,
      };
    } catch (error) {
      console.error("Error checking duplicate request:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },
};